<template>
  <div class="app-main">
    <!-- <keep-alive :include="cachedViews"> -->
    <breadcrumb />
    <keep-alive exclude="newUser,NewAdmUser">
      <router-view :key="key" />
    </keep-alive>
  </div>
</template>

<script>
import breadcrumb from './breadcrumb/index';

export default {
	name: 'AppMain',
	components: {
		breadcrumb,
	},
	computed: {
		// cachedViews() {
		//   return this.$store.state.tagsView.cachedViews;
		// },
		key() {
			return this.$route.path;
		},
	},
};
</script>

<style lang="scss" scoped>
.app-main {
  // width: 95%;
  width: calc(100% - 42px);
  align-self: center;
}
</style>
